var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{attrs:{"outlined":"","items":_vm.getItems,"label":_vm.generateLabel,"rules":_vm.isItRequired,"value":_vm.defaultValue,"hint":_vm.field.hint,"item-text":"title","item-value":"value","return-object":"","disabled":_vm.isDisabled},on:{"change":_vm.handleSelection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }